import { useState } from "react";
import { HStack, TabList, TabPanel, Tabs } from "@chakra-ui/react";
import { Tab, TabPanels } from "components";
import { AllCicoTransfer, InitiateCicoTransfer } from "ui";

interface IProps {
  tabChange: (tab: number) => void;
}
const CicoTransfer = ({ tabChange }: IProps) => {
  const [tabIndex, changeTab] = useState(0);
  const handleTabChange = (index: number) => {
    changeTab(index);
  };

  return (
    <Tabs variant="ghost" index={tabIndex} onChange={handleTabChange}>
      <HStack w="100%" alignItems="center">
        <TabList w="100%" flex={{ base: "6", "2sm": "4" }} borderRadius="8px">
          <Tab noShadow fontSize="sm">
            Initiate Transfer
          </Tab>

          <Tab noShadow fontSize="sm">
            All Transfers
          </Tab>
        </TabList>
      </HStack>

      <TabPanels index={tabIndex} onChangeIndex={handleTabChange} mt="24px">
        <TabPanel padding={{ base: "1rem 8px", "2sm": "1rem" }}>
          <InitiateCicoTransfer handleTabChange={handleTabChange} tabChange={tabChange} />
        </TabPanel>

        <TabPanel padding={{ base: "1rem 8px", "2sm": "1rem" }}>
          <AllCicoTransfer />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
};

export default CicoTransfer;
